import React from 'react';
import { FileText, Download } from 'lucide-react';

const RessourcesGratuitesTab = () => {
  return (
    <div data-testid="ressources-gratuites-tab">
      <h2 className="heading-2" style={{ marginBottom: '0.5rem' }}>
        Ressources Gratuites
      </h2>
      <p className="body-small" style={{ color: 'var(--text-secondary)', marginBottom: '2rem' }}>
        Documents et supports offerts avec votre formation. De nouvelles ressources seront ajout{"é"}es r{"é"}guli{"è"}rement.
      </p>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))', gap: '1.5rem' }}>
        {[
          {
            id: 'soin-change-eaje',
            title: 'Le Soin de Change en EAJE',
            description: 'S\u00e9curit\u00e9, Hygi\u00e8ne et Bienveillance - Guide complet des bonnes pratiques pour le soin de change en structure d\'accueil de jeunes enfants.',
            downloadUrl: '/downloads/ressources/soin-de-change-eaje.png',
            fileType: 'Image PNG',
          }
        ].map(resource => (
          <div
            key={resource.id}
            data-testid={`resource-card-${resource.id}`}
            className="card"
            style={{
              padding: '1.5rem',
              display: 'flex',
              flexDirection: 'column',
              gap: '1rem',
              border: '1px solid var(--border-light)',
              transition: 'box-shadow 0.2s ease',
            }}
            onMouseEnter={e => e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.1)'}
            onMouseLeave={e => e.currentTarget.style.boxShadow = 'none'}
          >
            <div style={{ display: 'flex', alignItems: 'flex-start', gap: '1rem' }}>
              <div style={{
                width: '48px', height: '48px', borderRadius: '12px',
                background: 'linear-gradient(135deg, #fce7f3, #fbcfe8)',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                flexShrink: 0
              }}>
                <FileText size={24} style={{ color: '#be185d' }} />
              </div>
              <div style={{ flex: 1 }}>
                <h3 style={{ fontSize: '1rem', fontWeight: 600, marginBottom: '0.4rem', color: 'var(--text-primary)' }}>
                  {resource.title}
                </h3>
                <p className="body-small" style={{ color: 'var(--text-secondary)', lineHeight: 1.5 }}>
                  {resource.description}
                </p>
              </div>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginTop: 'auto' }}>
              <span style={{
                fontSize: '0.75rem', color: 'var(--text-muted)',
                padding: '0.2rem 0.6rem', background: 'var(--bg-card)', borderRadius: '4px',
                border: '1px solid var(--border-light)'
              }}>
                {resource.fileType}
              </span>
              <a
                href={resource.downloadUrl}
                download
                data-testid={`download-${resource.id}`}
                className="btn-primary"
                style={{
                  padding: '0.5rem 1rem', fontSize: '0.85rem',
                  display: 'inline-flex', alignItems: 'center', gap: '0.5rem',
                  textDecoration: 'none'
                }}
              >
                <Download size={16} />
                T{"é"}l{"é"}charger
              </a>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default RessourcesGratuitesTab;
